import { ManageComplaintDeleteDailogueComponent } from './../manage-complaint-delete-dailogue/manage-complaint-delete-dailogue.component';
import { NewComplaintsDialogComponent } from './../new-complaints-dialog/new-complaints-dialog.component';
import { ManageComplaintViewtasksDialogComponent } from '../manage-complaint-viewtasks-dialog/manage-complaint-viewtasks-dialog.component';
import { ManageComplaintsService } from './../../services/manage-complaints/manage-complaints.service';
import { MatDialog } from '@angular/material';
import { Component, OnInit } from '@angular/core';
import { ServerDataSource } from 'ng2-smart-table';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AddTaskComponent } from '../add-task/add-task.component';
import { ParComplaintsDocumentsComponent } from '../par-complaints-documents/par-complaints-documents.component';
import { ManageComplaintViewDocumentsDialogueComponent } from '../manage-complaint-view-documents-dialogue/manage-complaint-view-documents-dialogue.component'
import { ManageComplaintTimelineDialogComponent } from '../manage-complaint-timeline-dialog/manage-complaint-timeline-dialog.component';

@Component({
  selector: 'app-manage-complaints',
  templateUrl: './manage-complaints.component.html',
  styleUrls: ['./manage-complaints.component.css']
})

export class ManageComplaintsComponent implements OnInit {
  data: any;
  public role: string;
  private complaints = "/complaints";
  activeOrInActive: any;
  source: ServerDataSource;
  url = environment.configURI;
  deleteId: any;
  disableDelete: boolean = false;
  settings: any;
  selectedIndex: any;

  constructor(private http: HttpClient,
    public dialog: MatDialog,
    public manageComplaintService: ManageComplaintsService) {
  }
  ngOnInit() {
    this.reloadTable();
    this.updateList();
    this.role = localStorage.getItem('Role');
    this.settings = {
      /* To remove actions for deleted complaints*/
      rowClassFunction: (row) => {
        if(row.data.Status == 'Deleted'){
          return 'hide-actions';
        }else{
          return '';
        }
      },
      actions: {
        position: "right",
        class: "action-column",
        custom: [
          {
            name: 'editAction',
            title: '<i class="material-icons">edit</i>'
          },
          {
            name: 'addTask',
            title: '<i class="material-icons">' + '<img src="../../../assets/images/icons/addTask.png" title="Add Task" height="24" width="24">' + '</i>'
          },
          {
            name: 'viewTaks',
            title: '<i class="material-icons">' + '<img src="../../../assets/images/icons/tasks.png" title="View Tasks" height="24" width="24">' + '</i>'
          },
          {
            name: 'addDoc',
            title: '<i class="material-icons">' + '<img src="../../../assets/images/icons/add-document.png" title="Add Document" height="24" width="24">' + '</i>'
          },
          {
            name: 'viewDocs',
            title: '<i class="material-icons">' + '<img src="../../../assets/images/icons/show_documents.png" title="View Documents" height="24" width="24">' + '</i>'
          },
          {
            name: 'RelateComplaint',
            title: '<i class="material-icons">' + '<img src="../../../assets/images/icons/add-link.png" title="Relate Complaint" height="24" width="24">' + '</i>'
          },
          {
            name: 'Timeline',
            title: '<i class="material-icons">' + '<img src="../../../assets/images/icons/timeline.png" title="Timeline" height="24" width="24">' + '</i>'
          }
        ],
        // disableDelete ? 'material-icons icon_gray': 'material-icons'
        //this.disableDelete ? '' : ''
        add: false,
        edit: false,
        delete: false
      },
      noDataMessage: 'No Complaints Found',
      columns: {
        ParStockNumber: {
          title: 'PAR Stock#',
          // width: "100px"
        },
        VIN: {
          title: 'VIN',
          // width: "100px"
        },
        ComplaintType: {
          title: 'Type',
          // width: "200px"
        },
        RegionId: {
          title: 'Region',
          // width: '300px'
        },
        State: {
          title: "State",
          // width: "275px"
        },
        FirstName: {
          title: "First Name",
          // width: "400px"
        },
        LastName: {
          title: 'Last Name',
          // width: "400px"
        },
        ClientName: {
          title: 'Client Name',
          // width: "500px"
        },
        Status:{
          title: 'Status',
        },
        MasterVendorName: {
          title: "Vendor",
          // width: "500px"
        },
        UserName: {
          title: 'Users',
          // width: "250px"
        }
      },
      pager:
        {
          perPage: 50
        }
    };
    /***
     * If Role is Resolution Manager Add the delete icon at the 2nd position
     *  */
    if(this.role && this.role === 'PC Resolution Manager' ||this.role && this.role === 'PC Site Admin' ){
      this.settings.actions.custom.splice(1,0,{
        name: 'deleteAction',
        title: '<i class="material-icons">close</i>'
      });
    }
  }

  reloadTable() {
    this.source = new ServerDataSource(this.http, { endPoint: `${this.url}${this.complaints}${'/active'}` });
  }
  inactiveList(){
    this.source = new ServerDataSource(this.http, { endPoint: `${this.url}${this.complaints}${'/inactive'}` });
  }


  updateList(){
    this.manageComplaintService.load.subscribe(res =>{
      if(res === 'Added Complaint'){
        this.reloadTable();
        this.selectedIndex = 0;
      } else if(res === 'updated active complaint' || res === 'deleted active complaint'){
        this.reloadTable();
        this.selectedIndex = 0;
      } else if(res === 'updated inactive complaint' || res === 'deleted inactive complaint'){
        this.inactiveList();
        this.selectedIndex = 1;
      } else if(res === 'InActive Relate Complaint' || res === 'Active Relate Complaint'){
        this.selectedIndex = 0;
        this.reloadTable();
      }
    })
  }

  changeToggle(event) {
    this.activeOrInActive = event.index;
    if (this.activeOrInActive == 0) {
      this.reloadTable();
    } else if(this.activeOrInActive == 1) {
      this.inactiveList();
    }
  }

  newComplaint(): void {
    const dialogRef = this.dialog.open(NewComplaintsDialogComponent, {
      disableClose: true,
      width: '65%',
      height: '88%',
      data: { status: 'create' }
    });
  }

  editComplaint(editData): void {
    const dialogRef = this.dialog.open(NewComplaintsDialogComponent, {
      disableClose: true,
      width: '65%',
      height: '88%',
      data: { status: editData.ComplaintStatus, complaintData: editData, type: 'update' }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  relateComplaints(data){
    const dialogRef = this.dialog.open(NewComplaintsDialogComponent, {
      disableClose: true,
      width: '65%',
      height: '88%',
      data: { type: 'relate', status: data.ComplaintStatus, complaintData: data}
    });
  }

  deleteManageComplaint(getDeleteData) {
   this.role = localStorage.getItem("Role");
   if (this.role === "PC Resolution Manager"  || this.role === "PC Site Admin") {
      // this.deleteId = getDeleteData.ComplaintId;
      this.deleteComplaint(getDeleteData);
    }else {
      this.disableDelete = true;
    }
  }

  deleteComplaint(data) {
    const dialogRef = this.dialog.open(ManageComplaintDeleteDailogueComponent, {
      disableClose: true,
      width: '400px',
      height: '250px',
      data: { deleteComplaintData: data }
    });
  }

  onCustomAction(event) {
    switch (event.action) {
      case 'editAction':
        this.editComplaint(event.data);
        break;
      case 'deleteAction':
         this.deleteManageComplaint(event.data);
        break;
      case 'addTask':
        this.addTask(event.data);
        break;
      case 'viewTaks':
        this.viewTask(event.data);
        break;
      case 'addDoc':
        this.addDoc(event.data);
        break;
      case 'viewDocs':
        this.viewDocs(event.data);
        break;
      case 'RelateComplaint':
        this.relateComplaints(event.data);
        break;
      case 'Timeline':
        this.timeline(event.data);
        break;
    }
  }

  addTask(data): void {
    const dialogRef = this.dialog.open(AddTaskComponent, {
      disableClose: true,
      width: '55%',
      height: '80%',
      data: {
        complaintData: data
      }
    });
  }

  viewTask(complaintId): void {
    const dialogRef = this.dialog.open(ManageComplaintViewtasksDialogComponent, {
      disableClose: true,
      width: '70%',
      height: '75%',
      data: { complaintId: complaintId }
    });
  }

  addDoc(data): void {
    const dialogRef = this.dialog.open(ParComplaintsDocumentsComponent, {
      disableClose: true,
      width: '40%',
      data: {
        ComplaintId : data.ComplaintId
      }
    });
  }

  viewDocs(data): void {
    const dialogRef = this.dialog.open(ManageComplaintViewDocumentsDialogueComponent, {
      disableClose: true,
      width: '70%',
      height: '75%',
      data: { ComplaintId : data.ComplaintId }
    });
  }

  timeline(data): void {
    const dialogRef = this.dialog.open(ManageComplaintTimelineDialogComponent, {
      disableClose: true,
      width: '70%',
      height: '80%',
      data: {
        complaintData: data
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/manage-complaints/manage-complaints.component.ts